import React, { useCallback, useMemo, useState } from "react";
import EmailJoinCampaignForm from "./EmailJoinCampaignForm";
import EmailCampaignJoinConfirmation from "../join-campaign-confirmation/EmailCampaignJoinConfirmation";
import { Icon, Typography } from "@mui/material";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

type EmailTemplate = {
  id: string | number;
};

type EmailLocation = {
  id: string | number;
  [key: string]: unknown;
};

type EmailCampaign = {
  name: string;
  templates: EmailTemplate[];
  locations: EmailLocation[];
  [key: string]: unknown;
};

type EmailSelection = Record<string | number, Record<string, unknown>>;

function EmailJoinCampaign({ campaign }: { campaign: EmailCampaign }) {
  const [selections, setSelections] = useState<EmailSelection | null>(null);
  const [confirm, setConfirm] = useState(false);

  const initialValues = useMemo(() => {
    return campaign.locations.reduce(
      (t, l) => ({
        ...t,
        [l.id]: {
          template: campaign.templates[0].id,
          schedule_type: "",
          schedule_date: "",
          schedule_time: "",
          locationInfo: l,
          ...selections?.[l.id],
        },
      }),
      {}
    );
  }, [campaign, selections]);

  const handleSubmit = useCallback((data: EmailSelection) => {
    setSelections(data);
    setConfirm(true);
  }, []);

  const handleMakeChanges = useCallback(() => {
    setConfirm(false);
  }, []);

  const handleOnDeleteLoc = useCallback((locId: string | number) => {
    setSelections((p) => {
      const c = { ...p };
      delete c[locId];
      return c;
    });
  }, []);

  if (confirm) {
    return (
      <EmailCampaignJoinConfirmation
        onMakeChange={handleMakeChanges}
        selections={selections}
        campaign={campaign}
        onDeleteLoc={handleOnDeleteLoc}
      />
    );
  }
  return (
    <div className="join-email-campaign">
      <Typography component="h2" variant="h6" className="mb-4 mb-md-auto">
        <Icon
          component={RpSvgIcon}
          name="campaign"
          color="primary"
          className="mr-2"
        />
        {`${campaign.name} Email Campaign`}
      </Typography>
      <EmailJoinCampaignForm
        campaign={campaign}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      />
    </div>
  );
}

export default EmailJoinCampaign;
